import { api } from "@/lib/api";

// Cached fetch of the owner-editable main navigation (GET /api/nav).
let cache = null;
let pending = null;

const FALLBACK = [
  { label: "Home", url: "/" },
  { label: "Map", url: "/map" },
  { label: "Ask", url: "/ask" },
];

export function fetchNav(force = false) {
  if (cache && !force) return Promise.resolve(cache);
  if (!pending || force) {
    pending = api
      .get("/nav")
      .then((r) => {
        cache = Array.isArray(r.data?.items) && r.data.items.length ? r.data.items : FALLBACK;
        return cache;
      })
      .catch(() => {
        cache = FALLBACK;
        return cache;
      })
      .finally(() => {
        pending = null;
      });
  }
  return pending;
}

export function clearNavCache() {
  cache = null;
}
